module.exports = __webpack_public_path__ + "media/delfin_m.3ff65e69.mp3";